// Application Routes - Matching Flutter AppRoute enum
export const ROUTES = {
  // Public routes (no auth required)
  signIn: '/sign-in',
  register: '/register',
  verificationCode: '/verification-code',
  resetPassword: '/reset-password',
  resetPasswordPath: '/reset-password/:path',
  setPassword: '/set-password',

  // Onboarding routes (auth required, partial setup)
  collegeDetailsVerification: '/college-details-verification',
  collegeVerification: '/college-verification',
  collegeCompaniesDetails: '/college-companies-details',

  // Main app routes (auth required)
  dashboard: '/dashboard',
  manageCandidates: '/manage-candidates/:path',
  manageJobs: '/manage-jobs/:path',
  manageApplications: '/manage-applications/:path',
  manageCourse: '/manage-course',
  courseManagement: '/course-management',
  announcements: '/announcements',
  notifications: '/notifications',
  settings: '/settings/:path',
  profileSettings: '/settings/:path',
  tpoSettings: '/tpo-settings',

  // Job routes
  jobs: '/jobs',
  jobDetails: '/job-details',
  jobPreview: '/job-preview',
  reviewApplication: '/review-application',

  // Batch routes
  batchManagement: '/batches-management',
  createBatch: '/create-batch',
  batchDetails: '/batch-details',

  // Learning routes
  learningModule: '/learning-module',

  // Calendar routes
  eventCalendar: '/event-calendar',

  // Reports
  reportsAndAnalytics: '/reports-and-analytics',
} as const;

// Route titles - Matching Flutter AppRoute titles
export const ROUTE_TITLES: Record<string, string> = {
  [ROUTES.signIn]: 'Sign In',
  [ROUTES.register]: 'Register',
  [ROUTES.verificationCode]: 'Verification Code',
  [ROUTES.resetPassword]: 'Reset Password',
  [ROUTES.setPassword]: 'Set Password',
  [ROUTES.collegeDetailsVerification]: 'College Details Verification',
  [ROUTES.collegeVerification]: 'College Verification',
  [ROUTES.collegeCompaniesDetails]: 'College Companies Details',
  [ROUTES.dashboard]: 'Dashboard',
  [ROUTES.manageCandidates]: 'Manage Candidates',
  [ROUTES.manageJobs]: 'Manage Jobs',
  [ROUTES.manageApplications]: 'Manage Applications',
  [ROUTES.manageCourse]: 'Manage Course',
  [ROUTES.announcements]: 'Announcements',
  [ROUTES.settings]: 'Settings',
  [ROUTES.batchManagement]: 'Batch Management',
  [ROUTES.createBatch]: 'Create Batch',
  [ROUTES.batchDetails]: 'Batch Details',
  [ROUTES.learningModule]: 'Learning Module',
  [ROUTES.eventCalendar]: 'Events Calendar',
  [ROUTES.jobPreview]: 'Job Preview',
  [ROUTES.reportsAndAnalytics]: 'Reports & Analytics',
};

// Navigation menu items - Matching Flutter NavMenuItems
export const NAV_MENU_ITEMS = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    path: ROUTES.dashboard,
    icon: 'dashboard',
  },
  {
    key: 'manageJobs',
    title: 'Manage Jobs',
    path: ROUTES.manageJobs.replace(':path', 'pending-jobs'),
    icon: 'work',
    featureFlag: 'enableV2ManageJobs',
  },
  {
    key: 'manageCandidates',
    title: 'Manage Candidates',
    path: ROUTES.manageCandidates.replace(':path', 'all-candidates'),
    icon: 'people',
  },
  {
    key: 'manageCourse',
    title: 'Manage Course',
    path: ROUTES.manageCourse,
    icon: 'school',
    featureFlag: 'enableV2ManageCourse',
  },
 
  {
    key: 'manageApplications',
    title: 'Manage Applications',
    path: ROUTES.manageApplications.replace(':path', 'all-applications'),
    icon: 'assignment',
    featureFlag: 'enableManageJobApplicationTab',
  }, 
  {
    key: 'batchManagement',
    title: 'Batch Management',
    path: ROUTES.batchManagement,
    icon: 'batch',
  }
] as const;

// Helper to generate path with params
export const generatePath = (path: string, params: Record<string, string>): string => {
  let result = path;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
};

// Settings menu items
export const SETTINGS_MENU_ITEMS = [
  { key: 'personal-info', title: 'Personal Information', featureFlag: 'enableV2ProfileSettingsPersonalInfo' },
  { key: 'college-details', title: 'College/Institute Details', featureFlag: 'enableV2ProfileSettingsCollegeDetails' },
  { key: 'kyc', title: 'KYC Verification', featureFlag: 'enableV2ProfileSettingsKYC' },
  { key: 'team', title: 'Team Management', featureFlag: 'enableV2ProfileSettingsTeam' },
  { key: 'stages', title: 'Manage Stages', featureFlag: 'enableV2ProfileSettingsManageStageTracking' },
  { key: 'tpo-settings', title: 'TPO Settings', featureFlag: 'enableV2TPOSettings' },
  { key: 'help', title: 'Help & Support', featureFlag: 'enableV2ProfileSettingsHelp' },
] as const;
